module.exports = __webpack_public_path__ + "img/Illustration.0116ad35.png";